module.exports = __webpack_public_path__ + "assets/img/11.0c1aa386.png";